"use client";

import { clsx } from "@trydig/ui";
import { type PropsWithChildren, Suspense } from "react";
import { createPortal } from "react-dom";
import { useHasHydrated } from "~/lib/hooks/useHasHydrated";
import { useOutsideClick } from "~/lib/hooks/useOutsideClick";
import styles from "./modal.module.css";

const UnsuspendedModal = ({
	children,
	isOpen,
	callback,
	className,
}: PropsWithChildren<{
	isOpen: boolean;
	callback: () => void;
	className?: string;
}>) => {
	const ref = useOutsideClick(callback);

	const isHydrated = useHasHydrated();

	if (!isOpen) {
		return null;
	}

	if (isHydrated) {
		return (
			<>
				{/* @ts-ignore */}
				{createPortal(
					<div className={clsx(styles.modal, className)} ref={ref}>
						{/* @ts-ignore */ children}
					</div>, // @ts-ignore
					document.body, // @ts-ignore
				)}
			</>
		);
	}

	return null;
};

export const Modal: typeof UnsuspendedModal = (props) => {
	return (
		<Suspense>
			<UnsuspendedModal {...props} />
		</Suspense>
	);
};
